<template>
  <div v-if="hasPlayers">
    <div class="row">
      <div class="col-md-12">
        <h3>Jugadores pendientes ({{ playersLength }})</h3>
      </div>
    </div>
    <div class="row" v-if="hasPlayers">
      <div class="col-sm-2">
        <input v-model="filterKey" placeholder="Search..." class="form-control">
      </div>
      <div class="col-sm-10">
        <button class="btn btn-default" @click="clearSearch">Limpiar</button>
      </div>
    </div>
    <br>
    <div class="row" v-if="hasPlayers">
      <div class="col-md-12">
        <players-table :players="players[date.id]" :filter-key.sync="filterKey" :list-type="listType"></players-table>
      </div>
    </div>
  </div>
</template>

<style>

</style>
<script>
  import PlayersTable from '../components/PlayersTable'
  import * as actions from '../vuex/actions'
  import {
    getCurrentDate,
    getPlayersWaiting
  } from '../vuex/getters'
  export default{
    components: { PlayersTable },
    vuex: {
      getters: {
        date: getCurrentDate,
        players: getPlayersWaiting
      },
      actions: actions
    },
    data() {
      return {
        filterKey: '',
        listType: 'waiting'
      }
    },
    computed: {
      hasPlayers() {
        return this.playersLength > 0
      },
      playersLength() {
        let length = 0
        if (this.date) {
          if (this.players[this.date.id] !== undefined) {
            length = this.players[this.date.id].length
          }
        }
        return length
      }
    },
    methods: {
      clearSearch() {
        this.filterKey = ''
      }
    }
  }
</script>



/** WEBPACK FOOTER **
 ** PlayersWaiting.vue?7d96c5d3
 **/